module.exports = __webpack_public_path__ + "media/application/images/svgs/corner-down-right-0c4f09c9b5e94132bc6d8f086cbd59a3.svg";